<template lang="pug">
	.step
		.step__title
			|Укажите данные страхователя
		.step__list
			.step__item.step__item_large
				.step__item-right
					//- .input
						//- Vue-suggestions(:model.sync="insurerName", :placeholder="'Фамилия Имя Отчество'", class="input__control", :options="suggestionOptions")
					app-suggestion(:input="schema.insurerName", @handleInput="handleInputName", :model.sync="insurerName",:options="suggestionOptions")
					//- input.input__control
					//- app-input(:input="schema.insurerName", :field.sync="insurerName")
		
			.step__item.step__item_large
				.step__item-right
					app-input(:input="schema.birthDate", :field.sync="birthDate")
			.step__item.step__item_large
				.step__item-right
					app-input(:input="schema.passport", :field.sync="passport", @handleInput="handleInput")
			.step__item.step__item_large
				.step__item-right
					app-suggestion(:input="schema.address", :model.sync="address", :coordinates.sync="coordinates", :options="suggestionOptionsAddress")
					//- app-input(:input="schema.address", :field.sync="address")
		.step__button( :class="$style.step__button")
			.step__button-block
						.step__text-summ
							|Стоимость полиса {{totalCost | numeric}} ₽
			.step__buttons( :class="$style.step__buttons")
				a.button.button_type-simple( :class="$style.button_type" href="#",  @click.prevent="handleClickPrev")
					|<-
				a.button( :class="$style.button" href="#", ref="buttonNext", @click.prevent="handleClick")
					|Далее
</template>

<script>
// @ is an alias to /src
import AppInput from '@/components/Input.vue'
import AppSuggestion from '@/components/Suggestion.vue'
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

// import VueSuggestions from 'vue-suggestions';
export default {

  name: 'app-step2',
  components: {
    AppInput,
    AppSuggestion,
    // VueSuggestions
  },
  data() {
  	return {
      coordinates: {
        latitude: '',
        longitude: ''
      },
      suggestionOptions: {
        token: '4e29d51c4d938ea6f685cb0a0bed225fbba9e3ee',
        type: "NAME",
        scrollOnFocus: false,
        triggerSelectOnBlur: true,
        triggerSelectOnEnter: false,
        addon: 'none',
        onSelect: (suggestion) => {
          this.insurerGender = suggestion.data.gender[0]
        	// this.insurerName = `${suggestion.data.surname} ${suggestion.data.name} ${suggestion.data.patronymic}`
        },
        onSelectNothing(suggestion){
        	// console.log('nothing', suggestion, this)
        	// this.insurerName = '';
        	// this.value = '';
        }
      },
      suggestionOptionsAddress: {
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454318
        token: '4e29d51c4d938ea6f685cb0a0bed225fbba9e3ee',
        type: "ADDRESS",
        scrollOnFocus: false,
        triggerSelectOnBlur: true,
        triggerSelectOnEnter: false,
        addon: 'none',
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454320
        onSelect (suggestion) {
        	// console.log('selected',suggestion, this)
        },
        onSelectNothing(suggestion){
        	// console.log('nothing', suggestion)
        	// this.address = '';
        	this.value = '';
        	// console.log(this.nextSibling)
        }
      },
  	}
  },
  methods:{
  	handleClick(){
  		console.log(this)
  		this.$validator.validate().then(valid => {
        if (valid) {

           this.$router.push({name:'step3'})
        }
      });
		},
		handleInputName(e){
			console.log(e)
			// console.log('eee', this.insurerName)
		},
		handleClickPrev(){
			this.$router.push({name:'step1'})
		},
		handleInput(e){
			console.log(e)
		}
  },
  computed:{
  	...mapFields([
      'insurerName',
      'birthDate',
      'passport',
      'address',
      'insurerGender',
	  'totalCost',
    ]),
	
    ...mapGetters({
		  schema: 'getSchema',
		  // popupIsActive: 'PopupIsActive'
		})
  }

}
</script>

<style module lang="scss">
.button {
	width: 100%;
}
.step__button {

	flex-direction: column;

	display: flex;
	justify-content: space-between;;
}
.button_type {
	min-width: 54px;
	padding: 0 !important;
	height: 54px !important;
	width: 54px !important;
	border: solid #b9b9b9 1px;
    color: #6C6F71;
    font-weight: 700;
    background-color: #ecf1f7;
}
.step__buttons {
	justify-content: flex-end;
	max-width: 740px;
	width: 100%;
	gap: 15px;
	display: flex;
}
</style>

<style lang="scss">
.step__text-summ {
	color: #4d4d4d !important;
	font-weight: 800 !important;
	font-size: 20px !important;
}
</style>
